<div class="twc-mt-2 twc-mb-3">
    <cw-color-picker [color]="color" [label]="label" (colorChange)="colorChange($event)"
        [readonly]="!property.editable()">
    </cw-color-picker>
</div>